module.exports = __webpack_public_path__ + "media/BinaryCode_720_m.dfefb645.mp4";